import { withStyles } from '@material-ui/core/styles'
import Tooltip from '@material-ui/core/Tooltip'

const StyledTooltip = withStyles({
    tooltip: {
        background: '#333333',
        fontFamily: 'Avenir',
        fontSize: '14px',
        width: 'max-content',
    },
    arrow: {
        '&::before': {
            backgroundColor: '#333333',
            boxSizing: 'border-box',
        },
    },
})(Tooltip)

export default StyledTooltip
